<template>
  <span
    class="project-label"
    :style="`background-color: ${color};`"
  >
    {{ title }}
  </span>
</template>

<script>
export default {
  name: 'ProaProjectLabel',
  props: {
    title: String,
    color: String
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";

.project-label {
  color: white;
  font-size: 12px;
  font-weight: 600;
  display: inline-block;
  border-radius: 2px;
  padding: 0 4px;
  margin: 1px 5px 5px 0;
  white-space: nowrap;
}
</style>
